import React from "react";
import { withStyles } from "@material-ui/core";
import { Customer, CustomerSelector_GetValueComponent } from "@graphql";
import { Classes, ThemeType } from "@theme";
import { Spinner } from "@components";
import CustomerCard from "@customers/CustomerCard/CustomerCard";
import { Value } from "../base/utils";

type Props = {
  clearable: boolean;
  classes: Classes<typeof styles>;
  disabled?: boolean;
  onClear: (e: React.SyntheticEvent<any>) => void;
  onClearValue: (customerId: string) => void;
  value: Value[];
};

class CustomerSelectorValue extends React.Component<Props> {
  render() {
    return (
      <div style={{ flex: 1 }}>
        {this.props.value.map(({ value: id }) => (
          <CustomerSelector_GetValueComponent key={id} variables={{ id }}>
            {({ data, error, loading }) => {
              if (error) {
                return <div>Error: {error.toString()}</div>;
              }

              if (loading) {
                return <Spinner />;
              }

              return (
                <div style={{ marginBottom: 16 }}>
                  <CustomerCard
                    onParentClick={() => 0}
                    data={data.customerById as Partial<Customer>}
                    onDelete={() => this.props.onClearValue(id)}
                    withDelete={this.props.clearable && !this.props.disabled}
                  />
                </div>
              );
            }}
          </CustomerSelector_GetValueComponent>
        ))}
      </div>
    );
  }
}

const styles = (theme: ThemeType) => ({
  clear: {
    alignItems: "center",
    display: "flex",
    paddingRight: 16,
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,

    "& > svg": {
      opacity: 0.65,
      transition: theme.transitions.create("opacity", { duration: 100 })
    },

    "& > svg:hover": {
      opacity: 0.9,
      cursor: "pointer"
    }
  }
});

export default withStyles(styles as any)(CustomerSelectorValue);
